



















































import { Component, Vue, Prop } from 'vue-property-decorator'
import { Icon } from '@alpha/ink'
import { Question, Response } from '@/store/modules/survey-store-module'
import store from '@/store'
import DropdownButton from '@/components/DropdownButton.vue'
import Toggle from '@/components/Toggle.vue'
import { SliceOption } from './Utilities/ChartUtilities'
import { exportIndividualChart } from '@/utilities/highcharts-export'

@Component({
  components: {
    Icon,
    DropdownButton,
    Toggle
  }
})
export default class QuestionDropDownOptions extends Vue {
  @Prop({ required: true }) question!: Question & { responses: Response[] }
  @Prop({ required: true }) enableChartOptions!: boolean
  @Prop({ required: false }) readonly currentSlice!: SliceOption
  copiedTimeout: NodeJS.Timeout | null = null
  copied = false

  get questionConfig () {
    return store.getters.surveyConfiguration.questionConfigById(this.question.id)
  }

  get chartUrl () {
    const baseUrl = window.location.href.split('?')[0]
    let baseParams = '?'
    if (this.$route.query.admin) { // check the vue router because sometimes it hides the query
      baseParams += 'admin=true&'
    }
    baseParams += `question=${this.question.id}`
    if (this.currentSlice) {
      baseParams += `&slice=${encodeURIComponent(this.currentSlice.value)}`
    }
    return baseUrl + baseParams
  }

  toggleQuestionVisibility () {
    store.dispatch.surveyConfiguration.updateQuestionConfig({ questionId: this.question.id, visible: !this.questionConfig.visible })
  }

  exportChartAsPNG () {
    const chartInstance = store.getters.livechartRefs.chartRefMap[this.question.id]
    exportIndividualChart(chartInstance, 'image/png')
  }

  exportChartAsSVG () {
    const chartInstance = store.getters.livechartRefs.chartRefMap[this.question.id]
    exportIndividualChart(chartInstance, 'image/svg+xml')
  }

  copyChartUrl () {
    this.copied = false
    const shareLinkElement = this.$refs.shareLink as HTMLInputElement
    shareLinkElement.select()
    shareLinkElement.setSelectionRange(0, 99999) // mobile
    const success = document.execCommand('copy')
    this.setCopied(success)
  }

  setCopied (value: boolean) {
    if (this.copiedTimeout) {
      clearTimeout(this.copiedTimeout)
    }
    this.copied = value
    if (value) {
      this.copiedTimeout = setTimeout(() => {
        this.copied = false
      }, 3000)
    }
  }
}
